import React from 'react'
import { AuthProvider } from './context/AuthContext'
import { DataProvider } from './context/DataContext'
import { RouterProvider } from 'react-router-dom'
import ErrorBoundary from './components/ErrorBoundary'
import router from './router'
import { PrimeReactProvider } from 'primereact/api';
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './styles/form-controls.css';

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <DataProvider>
          <PrimeReactProvider>
            <RouterProvider router={router} />
          </PrimeReactProvider>
        </DataProvider>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App